import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl } from '@angular/forms';
import { SubscriptionPackage } from '@kodit/core/data-api';
import { Subscription } from "rxjs";

export interface PackageEventResult {
  packageId: string;
  packageType: SubscriptionPackage;
  incrementNumber?: number;
}

@Component({
  selector: 'kodit-package-box',
  templateUrl: './package-box.component.html',
  styleUrls: ['./package-box.component.scss'],
})
export class PackageBoxComponent implements OnInit, OnDestroy, OnChanges {
  private _subs: Subscription = new Subscription();

  @Input() label: string;
  @Input() price: number;
  @Input() priceLabel: string;
  @Input() packageId: string;
  @Input() packageType: SubscriptionPackage;
  @Input() isDisabled = false;
  @Input() shouldDisablePrice = true;
  @Input() isMain = false;
  @Input() showIncrementInput = false;
  @Input() isSelected = false;
  @Input() incrementValue = 0;

  @Output() packageSelected = new EventEmitter<PackageEventResult>();
  @Output() packageUnselected = new EventEmitter<PackageEventResult>();

  formControl = new FormControl(false);
  incrementControl = new FormControl(0);
  previousIncrement: number = 0;

  ngOnInit() {
    this._subs.add(
      this.incrementControl.valueChanges.subscribe((val) => {
        if (this.previousIncrement !== val) {
          this._onNumberChange(val);
        }
      })
    );
  }

  onCheckboxChange(value: boolean) {
    if (value) {
      this.packageSelected.emit({
        packageId: this.packageId,
        packageType: this.packageType,
      });
    } else {
      this.packageUnselected.emit({
        packageId: this.packageId,
        packageType: this.packageType,
      });
    }
  }

  onCardClicked() {
    if (this.isDisabled || !this.isMain) {
      return;
    }
    this.formControl.patchValue(!this.formControl.value);
    this.onCheckboxChange(this.formControl.value);
  }

  onLabelClicked() {
    if (this.isDisabled || this.isMain) {
      return;
    }
    this.formControl.patchValue(!this.formControl.value);
    this.onCheckboxChange(this.formControl.value);
  }

  private _onNumberChange(value: number) {
    if (value > this.previousIncrement) {
      this.packageSelected.emit({
        packageId: this.packageId,
        packageType: this.packageType,
        incrementNumber: value,
      });
    } else {
      this.packageUnselected.emit({
        packageId: this.packageId,
        packageType: this.packageType,
        incrementNumber: value,
      });
    }
    this.previousIncrement = value;
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isDisabled']?.currentValue && !changes['isDisabled']?.isFirstChange()) {
      this.formControl.patchValue(false);
      this.previousIncrement = 0;
      this.incrementControl.patchValue(0);
    }

    if (changes['isSelected']) {
      this.formControl.patchValue(this.isSelected, { emitEvent: false });
    }

    if (changes['incrementValue']) {
      this.incrementControl.patchValue(this.incrementValue, { emitEvent: false });
      this.previousIncrement = this.incrementValue;
    }
  }
}
